import { render, staticRenderFns } from "./GenericAccountImport.vue?vue&type=template&id=5cf8110c"
import script from "./GenericAccountImport.vue?vue&type=script&lang=js"
export * from "./GenericAccountImport.vue?vue&type=script&lang=js"
import style0 from "./GenericAccountImport.vue?vue&type=style&index=0&id=5cf8110c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports